import {
    GET_ALL_EMPLOIS_REQUEST, GET_ALL_EMPLOIS_SUCCESS, GET_ALL_EMPLOIS_FAIL,
    GET_EMPLOI_REQUEST, GET_EMPLOI_SUCCESS, GET_EMPLOI_FAIL,
    CREATE_EMPLOI_REQUEST, CREATE_EMPLOI_SUCCESS, CREATE_EMPLOI_FAIL,
    UPDATE_EMPLOI_REQUEST, UPDATE_EMPLOI_SUCCESS, UPDATE_EMPLOI_FAIL,
    DELETE_EMPLOI_REQUEST, DELETE_EMPLOI_SUCCESS, DELETE_EMPLOI_FAIL
} from '../actions/emploiActions';

const initialState = {
    emplois: [],
    currentEmploi: null,
    loading: false,
    error: null
};

export default function emploiReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_EMPLOIS_REQUEST:
        case GET_EMPLOI_REQUEST:
        case CREATE_EMPLOI_REQUEST:
        case UPDATE_EMPLOI_REQUEST:
        case DELETE_EMPLOI_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_EMPLOIS_SUCCESS:
            return {
                ...state,
                emplois: action.payload,
                loading: false
            };
        case GET_EMPLOI_SUCCESS:
            return {
                ...state,
                currentEmploi: action.payload,
                loading: false
            };
        case CREATE_EMPLOI_SUCCESS:
            return {
                ...state,
                emplois: [...state.emplois, action.payload],
                loading: false
            };
        case UPDATE_EMPLOI_SUCCESS:
            return {
                ...state,
                emplois: state.emplois.map(e => e.id === action.payload.id ? action.payload : e),
                loading: false
            };
        case DELETE_EMPLOI_SUCCESS:
            return {
                ...state,
                emplois: state.emplois.filter(e => e.id !== action.payload),
                loading: false
            };
        case GET_ALL_EMPLOIS_FAIL:
        case GET_EMPLOI_FAIL:
        case CREATE_EMPLOI_FAIL:
        case UPDATE_EMPLOI_FAIL:
        case DELETE_EMPLOI_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
}
